function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["totalNumberOfPages", "activePage", "previousText", "nextText", "ariaLabelPageNumber", "ariaLabelCurrentPage", "ariaLabelNextPage", "ariaLabelPreviousPage", "ariaLabelFirstPage", "ariaLabelLastPage", "align", "className", "onPageChange"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import { number, string, oneOf, func } from 'prop-types';
import classNames from 'classnames';
import './Pagination.scss';
import Icon from '../Icon/Icon';
import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon, ChevronRightIcon, ChevronLeftIcon } from '@ruter-ds/rds-icons';
var propTypes = {
  /** The current active page. */
  activePage: number,

  /** The total number of pages. */
  totalNumberOfPages: number,

  /** Text on the PREVIOUS navigation item. (This text is visually hidden). */
  previousText: string,

  /** Text on the NEXT navigation item. (This text is visually hidden). */
  nextText: string,

  /** Will render as "Your text" + page number as an aria-label on the navigation item.
   * Example `"Go to page 12"` */
  ariaLabelPageNumber: string,

  /** Will render as "Your text" + page number as an aria-label on the navigation item.
   * Example `"Current Page, Page 3"` */
  ariaLabelCurrentPage: string,

  /** Aria-label on the next page navigation item. */
  ariaLabelNextPage: string,

  /** Aria-label on the previous page navigation item. */
  ariaLabelPreviousPage: string,

  /** Aria-label on the go to first page navigation item. */
  ariaLabelFirstPage: string,

  /** Aria-label on the go to last page navigation item. */
  ariaLabelLastPage: string,

  /** Align pagination-list to the start, center or end of the current flexbox context  */
  align: oneOf(['start', 'center', 'end']),

  /** Callback function */
  onPageChange: func,

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  activePage: 1,
  previousText: 'Prev',
  nextText: 'Next',
  ariaLabelPageNumber: 'Go to page',
  ariaLabelCurrentPage: 'Current page, page',
  ariaLabelNextPage: 'Go to next page',
  ariaLabelPreviousPage: 'Go to previous page',
  ariaLabelFirstPage: 'Go to page 1',
  ariaLabelLastPage: 'Go to last page',
  align: 'center'
};
/**
 * Pagination can be used when you need to navigate between large portion of content.
 */

var Pagination = /*#__PURE__*/function (_Component) {
  _inherits(Pagination, _Component);

  var _super = _createSuper(Pagination);

  function Pagination(props) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _super.call(this, props);
    _this.onPageChange = _this.onPageChange.bind(_assertThisInitialized(_this));
    _this.goToPreviousPage = _this.goToPreviousPage.bind(_assertThisInitialized(_this));
    _this.goToNextPage = _this.goToNextPage.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Pagination, [{
    key: "onPageChange",
    value: function onPageChange(page) {
      this.props.onPageChange(page);
    }
  }, {
    key: "goToPreviousPage",
    value: function goToPreviousPage() {
      if (this.props.activePage > 1) {
        this.props.onPageChange(this.props.activePage - 1);
      }
    }
  }, {
    key: "goToNextPage",
    value: function goToNextPage() {
      if (this.props.activePage < this.props.totalNumberOfPages) {
        this.props.onPageChange(this.props.activePage + 1);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          totalNumberOfPages = _this$props.totalNumberOfPages,
          activePage = _this$props.activePage,
          previousText = _this$props.previousText,
          nextText = _this$props.nextText,
          ariaLabelPageNumber = _this$props.ariaLabelPageNumber,
          ariaLabelCurrentPage = _this$props.ariaLabelCurrentPage,
          ariaLabelNextPage = _this$props.ariaLabelNextPage,
          ariaLabelPreviousPage = _this$props.ariaLabelPreviousPage,
          ariaLabelFirstPage = _this$props.ariaLabelFirstPage,
          ariaLabelLastPage = _this$props.ariaLabelLastPage,
          align = _this$props.align,
          className = _this$props.className,
          onPageChange = _this$props.onPageChange,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var margin = 2; // Create variables for start page and end page

      var startPage, endPage; //Check if the total number of pages is UNDER five.
      // If so, set start page and end page.

      if (totalNumberOfPages < 5) {
        startPage = 1;
        endPage = totalNumberOfPages;
      } // If total number of pages is OVER five, determine start page and end
      // page based on the active page.
      else {
          startPage = activePage > margin ? activePage - margin : 1;

          if (activePage + margin > totalNumberOfPages) {
            endPage = totalNumberOfPages;
            startPage = totalNumberOfPages - 4;
          } else {
            if (activePage === 1) {
              endPage = activePage + margin + 2;
            } else if (activePage === 2) {
              endPage = activePage + margin + 1;
            } else {
              endPage = activePage + margin;
            }
          }
        } // Never let start page be lower than 1


      if (startPage < 1) {
        startPage = 1;
      } // Create an array of all pages based on the total number of pages


      var pages = [];

      for (var i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      var componentClassNames = classNames('rds-pagination', {
        'rds-pagination--align-start': align === 'start',
        'rds-pagination--align-center': align === 'center',
        'rds-pagination--align-end': align === 'end'
      }, className);
      var pageItems = pages.map(function (page) {
        var buttonClassNames = classNames('rds-pagination-list__button', {
          'rds-pagination-list__button--active': page === activePage
        });

        if (page === activePage) {
          return /*#__PURE__*/React.createElement("li", {
            key: page,
            className: "rds-pagination-list__item"
          }, /*#__PURE__*/React.createElement("span", {
            className: buttonClassNames,
            "aria-label": "".concat(ariaLabelCurrentPage, " ").concat(page),
            "aria-current": page === activePage
          }, /*#__PURE__*/React.createElement("span", null, page.toString())));
        } else {
          return /*#__PURE__*/React.createElement("li", {
            key: page,
            className: "rds-pagination-list__item"
          }, /*#__PURE__*/React.createElement("button", {
            className: buttonClassNames,
            onClick: function onClick() {
              return _this2.onPageChange(page);
            },
            "aria-label": "".concat(ariaLabelPageNumber, " ").concat(page),
            "aria-current": page === activePage
          }, /*#__PURE__*/React.createElement("span", null, page.toString())));
        }
      });
      return /*#__PURE__*/React.createElement("nav", _extends({
        className: componentClassNames,
        role: "navigation",
        "aria-label": "Pagination Navigation"
      }, rest), /*#__PURE__*/React.createElement("span", {
        className: classNames({
          'rds-pagination-arrow--first-wrapper': align === 'center'
        })
      }, activePage > 2 && totalNumberOfPages > 5 && /*#__PURE__*/React.createElement("button", {
        className: "rds-pagination-arrow rds-pagination-arrow--first",
        onClick: function onClick() {
          return _this2.onPageChange(1);
        },
        "aria-label": ariaLabelFirstPage
      }, /*#__PURE__*/React.createElement(Icon, {
        component: /*#__PURE__*/React.createElement(ChevronDoubleLeftIcon, null),
        size: "small"
      }))), /*#__PURE__*/React.createElement("span", {
        className: classNames({
          'rds-pagination-arrow--prev-wrapper': align === 'center'
        })
      }, activePage > 1 && /*#__PURE__*/React.createElement("button", {
        className: "rds-pagination-arrow rds-pagination-arrow--prev",
        onClick: function onClick() {
          return _this2.goToPreviousPage();
        },
        "aria-label": ariaLabelPreviousPage
      }, /*#__PURE__*/React.createElement(Icon, {
        component: /*#__PURE__*/React.createElement(ChevronLeftIcon, null),
        size: "small"
      }), /*#__PURE__*/React.createElement("span", {
        className: "rds-is-vishidden"
      }, previousText))), /*#__PURE__*/React.createElement("ul", {
        className: "rds-pagination-list"
      }, pageItems), /*#__PURE__*/React.createElement("span", {
        className: classNames({
          'rds-pagination-arrow--next-wrapper': align === 'center'
        })
      }, activePage < totalNumberOfPages && /*#__PURE__*/React.createElement("button", {
        className: "rds-pagination-arrow rds-pagination-arrow--next",
        onClick: function onClick() {
          return _this2.goToNextPage();
        },
        "aria-label": ariaLabelNextPage
      }, /*#__PURE__*/React.createElement(Icon, {
        component: /*#__PURE__*/React.createElement(ChevronRightIcon, null),
        size: "small"
      }), /*#__PURE__*/React.createElement("span", {
        className: "rds-is-vishidden"
      }, nextText))), /*#__PURE__*/React.createElement("span", {
        className: classNames({
          'rds-pagination-arrow--last-wrapper': align === 'center'
        })
      }, activePage < totalNumberOfPages - 1 && totalNumberOfPages > 5 && /*#__PURE__*/React.createElement("button", {
        className: "rds-pagination-arrow rds-pagination-arrow--last",
        onClick: function onClick() {
          return _this2.onPageChange(totalNumberOfPages);
        },
        "aria-label": ariaLabelLastPage
      }, /*#__PURE__*/React.createElement(Icon, {
        component: /*#__PURE__*/React.createElement(ChevronDoubleRightIcon, null),
        size: "small"
      }))));
    }
  }]);

  return Pagination;
}(Component);

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;
export default Pagination;